module.exports = __webpack_public_path__ + "img/ip.2651cb0c.svg";